import type { FloatedBy, Tender, TenderCategory, TenderingMethod } from '@/types/domain';

/** Labels for the tender classification fields. Single source for forms, tables, filters and exports. */
export const TENDERING_METHOD_LABELS: Record<TenderingMethod, string> = {
  limited: 'Limited Tender',
  open: 'Open Tender',
  single: 'Single Tender',
};
export const TENDER_CATEGORY_LABELS: Record<TenderCategory, string> = {
  omc: 'OMC Tender',
  imed: 'Inter Department Tender',
};
export const FLOATED_BY_LABELS: Record<FloatedBy, string> = {
  cpo: 'CPO',
  hq: 'HQ',
};

export const TENDERING_METHODS = Object.keys(TENDERING_METHOD_LABELS) as TenderingMethod[];
export const TENDER_CATEGORIES = Object.keys(TENDER_CATEGORY_LABELS) as TenderCategory[];
export const FLOATED_BY_OPTIONS = Object.keys(FLOATED_BY_LABELS) as FloatedBy[];

export const tenderingMethodLabel = (v?: TenderingMethod | null) => (v ? TENDERING_METHOD_LABELS[v] ?? v : null);
export const tenderCategoryLabel = (v?: TenderCategory | null) => (v ? TENDER_CATEGORY_LABELS[v] ?? v : null);
export const floatedByLabel = (v?: FloatedBy | null) => (v ? FLOATED_BY_LABELS[v] ?? v : null);

/** CRFQ numbers: 3–64 letters, digits, "/", "-", "_" or "." with no spaces (e.g. 1000454175). */
export const CRFQ_PATTERN = /^[A-Za-z0-9][A-Za-z0-9/\-_.]{2,63}$/;

type Classified = Pick<Tender, 'tenderNumber' | 'tenderingMethod' | 'tenderCategory' | 'floatedBy'>;

/** Names of the required identification fields that are still empty (older tenders). */
export function missingClassification(t: Classified): string[] {
  const m: string[] = [];
  if (!t.tenderNumber) m.push('CRFQ Number');
  if (!t.tenderingMethod) m.push('Tender Type');
  if (!t.tenderCategory) m.push('Tender Category');
  if (!t.floatedBy) m.push('Floated By');
  return m;
}

export const isClassificationMissing = (t: Classified) => missingClassification(t).length > 0;
